import { useQuery } from '@tanstack/react-query';
import type { UseQueryOptions } from '@tanstack/react-query';
import { useApi } from 'services/api';
import type { paths } from 'types/schemas/api-schema';

type PcapProfilesResponse =
  paths['/tenants/{TenantId}/smf/profiles']['get']['responses']['200']['content']['application/json'];
type PcapProfile = NonNullable<PcapProfilesResponse['items']>[0];

/**
 * Fetches PCAP profiles for a specific tenant
 * @param tenantId - ID of the tenant
 * @param config - Query config
 */
export const usePcapProfiles = (
  tenantId: string,
  config?: UseQueryOptions<PcapProfilesResponse, Error, PcapProfile[]>,
) => {
  const api = useApi();

  return useQuery({
    queryKey: ['tenants', tenantId, 'smf', 'profiles', 'pcap'],
    queryFn: async () => {
      const response = await api.get(`/tenants/${tenantId}/smf/profiles`, {
        params: {
          QueryConstraint: JSON.stringify({ profileType: 'pcap' }),
        },
      });

      return response as PcapProfilesResponse;
    },
    enabled: Boolean(tenantId),
    select: (data) => data.items || [],
    ...config,
  });
};

export default usePcapProfiles;
